import { OrderListRow } from "../models/orderListModels";

export const filterOrderListRows = (
  rows: OrderListRow[],
  category: string,
  search: string
): OrderListRow[] => {
  const normalizedSearch = search.trim().toLowerCase();
  return rows
    .filter(row =>
      (category === "ALL" || row.category === category) &&
      row.ingredient.toLowerCase().includes(normalizedSearch)
    )
    .sort((left, right) =>
      left.category.localeCompare(right.category, undefined, { sensitivity: "base" }) ||
      left.ingredient.localeCompare(right.ingredient, undefined, { sensitivity: "base" })
    );
};